import baron from "src/assets/images/ticket/baron.png";
import counterImg from "src/assets/images/ticket/counter/counter.png";
import counterGif from "src/assets/images/ticket/counter/counter_gif.gif";
import counterNormalImg from "src/assets/images/ticket/counter/counter_normal.png";
import stageCounterImg from "src/assets/images/ticket/counter/stage_counter.png";
import duke from "src/assets/images/ticket/duke.png";
import earl from "src/assets/images/ticket/earl.png";
import incentiveImg from "src/assets/images/ticket/incentive/incentive.png";
import incentiveGif from "src/assets/images/ticket/incentive/incentive_gif.gif";
import incentiveNormalImg from "src/assets/images/ticket/incentive/incentive_normal.png";
import stageIncentiveImg from "src/assets/images/ticket/incentive/stage_incentive.png";
import presaleImg from "src/assets/images/ticket/presale/presale.png";
import presaleGif from "src/assets/images/ticket/presale/presale_gif.gif";
import presaleNormalImg from "src/assets/images/ticket/presale/presale_normal.png";
import stagePresaleImg from "src/assets/images/ticket/presale/stage_presale.png";
import viscount from "src/assets/images/ticket/viscount.png";

export const boxSaleAssets = {
  1: { name: "baron", image: baron },
  2: { name: "viscount", image: viscount },
  3: { name: "earl", image: earl },
  4: { name: "duke", image: duke },
};

export const BOXIDS = [1, 2, 3, 4];

export const ticketAssets = {
  incentive: {
    name: "Incentive Ticket",
    color: "#9481FF",
    image: incentiveImg,
    gifImage: incentiveGif,
    normalImage: incentiveNormalImg,
    stageImage: stageIncentiveImg,
    bgColor: "#2a3155",
    description:
      "In the process of joining the Missions of Trava Knight NFT and Minigames, users can also have opportunities of receiving Tickets as rewards.",
  },
  counter: {
    name: "Counter Ticket",
    color: "#1998F4",
    image: counterImg,
    gifImage: counterGif,
    normalImage: counterNormalImg,
    stageImage: stageCounterImg,
    bgColor: "#152d55",
    description: "Tickets from Trava Counter are the Tickets that users buy from Trava Counter with USDT.",
  },
  presale: {
    name: "Presale Ticket",
    color: "#4FB5FF",
    image: presaleImg,
    gifImage: presaleGif,
    normalImage: presaleNormalImg,
    stageImage: stagePresaleImg,
    bgColor: "#153448",
    description:
      "Tickets from Presale are Tickets that users buy from Presale with lower prices, compared to the Ticket bought from Trava Counter.",
  },
};
